import { Box } from "@mui/material";

interface LogoProps {
    width: string;
    imageSource: any;
    urlClick: string;
}
export default function Logo({ width, imageSource, urlClick }: LogoProps) {
    function openWebsite(url: string) {
        window.open(url, '_blank', 'noopener,noreferrer');

    }
    
    return (
        <Box
            component="img"
            sx={{
                // mr: 3,
                // ...(props.mobile ? {
                //     width: "45%"
                // } :
                // {
                width: width,
                '&:hover': {
                    cursor: 'pointer',
                },
                // }
                // ),
            }}
            src={imageSource}
            onClick={() => openWebsite(urlClick)}
        />
    )
}
